import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signup } from "../slice/clientAuth";
import { Link } from "react-router-dom";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientSignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    parent_name: "",
    email: "",
    address: "",
    about: "",
    password: "",
    phone: "",
    birthdate: "",
    // city: "",
    // state: "",
    // zipcode: "",
    // lat: "",
    // long: "",
    // country: "",
    profile_image: ""
  });

    const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "profile_image") {
    setFormData((prev) => ({
      ...prev,
      profile_image: files[0], // ✅ Store the file object, not the name
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};



 const handleSubmit = async (e) => {
  e.preventDefault();

  if (formData.password !== formData.confirm_password) {
        toast.error("Passwords do not match!", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
        });
        return;
    }

  const form = new FormData();

  // Append all fields to FormData
  for (const key in formData) {
    form.append(key, formData[key]);
  }

  const result = await dispatch(signup(form)); // ✅ Send FormData, not plain object

  if (result.meta.requestStatus === "fulfilled") {
    toast.success("Signup successful!", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    navigate("/signin");
  } else {
    toast.error("Signup failed. Please check your credentials.", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
  }
};


    return (
        // <div className="container mt-5">
        //     <h2 className="mb-4">Client Signup</h2>

        //     <form onSubmit={handleSubmit}>
        //         <div className="row mb-3">
        //             <div className="col-md-6">
        //                 <label className="form-label">First Name</label>
        //                 <input
        //                     type="text"
        //                     name="first_name"
        //                     className="form-control"
        //                     required
        //                     value={formData.first_name}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //             <div className="col-md-6">
        //                 <label className="form-label">Last Name</label>
        //                 <input
        //                     type="text"
        //                     name="last_name"
        //                     className="form-control"
        //                     required
        //                     value={formData.last_name}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //         </div>
        //         <div className="row mb-3">
        //             <div className="col-md-6">
        //                 <label className="form-label">Parent Name</label>
        //                 <input
        //                     type="text"
        //                     name="parent_name"
        //                     className="form-control"
        //                     required
        //                     value={formData.parent_name}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //             <div className="col-md-6">
        //                 <label className="form-label">Email ID</label>
        //                 <input
        //                     type="email"
        //                     name="email"
        //                     className="form-control"
        //                     required
        //                     value={formData.email}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //         </div>
        //         <div className="row mb-3">
        //             <div className="col-md-6">
        //                 <label className="form-label">Address</label>
        //                 <input
        //                     type="text"
        //                     name="address"
        //                     className="form-control"
        //                     required
        //                     value={formData.address}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //             <div className="col-md-6">
        //                 <label className="form-label">Profile Image</label>
        //                 <input
        //                     type="file"
        //                     name="profile_image"
        //                     className="form-control"
        //                     required
        //                     onChange={handleChange}
        //                 />
        //             </div>
                    
        //         </div>
        //         <div className="row mb-3">
        //             <div className="col-md-6">
        //                 <label className="form-label">Password</label>
        //                 <input
        //                     type="password"
        //                     name="password"
        //                     className="form-control"
        //                     required
        //                     value={formData.password}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //         </div>
        //         <div className="row mb-3">
        //             <div className="col-md-6">
        //                 <label className="form-label">Phone</label>
        //                 <input
        //                     type="number"
        //                     name="phone"
        //                     className="form-control"
        //                     required
        //                     value={formData.phone}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //             <div className="col-md-6">
        //                 <label className="form-label">BirthDate</label>
        //                 <input
        //                     type="date"
        //                     name="birthdate"
        //                     className="form-control"
        //                     required
        //                     value={formData.birthdate}
        //                     onChange={handleChange}
        //                 />
        //             </div>
        //         </div>
        //         <div className="row mb-3">
        //             <div className="col-md-12">
        //                 <label className="form-label">Message</label>
        //                 <textarea
        //                     type="text"
        //                     name="about"
        //                     className="form-control"
        //                     required
        //                     value={formData.about}
        //                     onChange={handleChange}
        //                 />
        //             </div>
                    
        //         </div>

        //         <button className="btn btn-primary">Signup</button>
        //     </form>
        //     <div className="row mt-3">
        //         <div className="col">
        //             Already have an account? <Link to="/signin" className="">Login</Link>
        //         </div>
        //     </div>
        // </div>
        <>
            <ClientHeader />
            <main className="overflow-hidden">
                <section className="homepad-signin">  
                    <div className="container">
                        <div className="row">
                            {/* 👶 Register Section */}
                            <div className="col-lg-6 left-panel-signin" 
                                style={{
                                    backgroundImage: "url('/assets/images/login-left.jpg')",
                                    backgroundRepeat: "no-repeat"
                                }}>
                                <div className="left-overlay-signin">
                                    <h2 className="montserrat font-weight-bold lh-1 font-size-60">Welcome, <span className="text-yellow">Parents</span> & <span className="text-yellow">Caregivers</span></h2>
                                    <div className="">
                                        <p className="m-0 font-size-14 lh-base">You are your child’s most powerful advocate—and you don’t have to navigate this journey alone. At The Just Generation Foundation, we’re here to help you recognize your child’s unique needs early and connect with trusted professionals who can guide you forward. Whether you're facing speech delays, behavioral concerns, or just a gut feeling that something isn’t quite right, our tools, referrals, and support resources are designed with you in mind. Because every child deserves the best start—and every parent deserves the right support. <br />
                                        🔵 Explore our screening tools, service providers, and family resources today.</p>
                                    </div>
                                    {/* <div className="d-flex align-items-center mt-3">
                                        <img src="https://randomuser.me/api/portraits/women/44.jpg" className="rounded-circle me-2" width="40" height="40" />
                                    <div>
                                    <div><strong className="montserrat font-weight-bold">Devon Lane</strong></div>
                                    <small>Co-Founder, Design.co</small>
                                </div>
                            </div> */}
                        </div>
                    </div>

                    {/* 🔐 Login Section */}
                    <div className="col-lg-6 form-section">
                        <div className="ps-lg-5">
                            <h3 className="font-weight-bold montserrat text-primary font-size-38 mb-3 lh-1">Register With Us</h3>
                            <p className="text-primary mb-4 font-size-16">Lorem Ipsum is simply dummy text of the Lorem Ipsum!</p>
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">First Name</label>
                                        <input
                                            type="text"
                                            name="first_name"
                                            className="form-control"
                                            placeholder="Enter First Name"
                                            value={formData.first_name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Last Name</label>
                                        <input
                                            type="text"
                                            name="last_name"
                                            className="form-control"
                                            placeholder="Enter Last Name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Parent Name</label>
                                        <input
                                            type="text"
                                            name="parent_name"
                                            className="form-control"
                                            placeholder="Enter Parent Name"
                                            value={formData.parent_name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Email ID</label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="Enter Email ID"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Phone</label>
                                        <input
                                            type="number"
                                            name="phone"
                                            className="form-control"
                                            placeholder="Enter Phone No"
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">BirthDate</label>
                                        <input
                                            type="date"
                                            name="birthdate"
                                            className="form-control"
                                            // placeholder="Enter Phone No"
                                            value={formData.birthdate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Password</label>
                                        <input
                                            type="password"
                                            name="password"
                                            className="form-control"
                                            placeholder="Enter Password"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Confirm Password</label>
                                        <input
                                            type="password"
                                            name="confirm_password"
                                            className="form-control"
                                            placeholder="Enter Confirm Password"
                                            value={formData.confirm_password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Address</label>
                                        <input 
                                            type="text"
                                            name="address"
                                            className="form-control"
                                            placeholder="Enter Address"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold">Profile Image</label>

                                        <div className="uploadfield">
                                            <div className="custom-file-upload">
                                                <button
                                                    type="button"
                                                    className="upload-btn btn btn-primary position-absolute"
                                                    onClick={() => document.getElementById('profileImage')?.click()}
                                                    >
                                                    Upload Files
                                                </button>
                                                <input
                                                    type="file"
                                                    id="profileImage"
                                                    name="profile_image"
                                                    accept=".jpg,.jpeg,.png"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="file-name form-control" id="fileName">
                                                {formData.profile_image?.name || "No file chosen"}
                                            </div>
                                            <div className="text-muted leaveblank d-block pt-1">Supported: JPG, JPEG, PNG. Max size: 1 MB.</div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Message</label>
                                        <textarea
                                            className="form-control"
                                            name="about"
                                            rows="3"
                                            placeholder="Enter Message"
                                            value={formData.about}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="termsCheck"
                                                checked={isChecked}
                                                onChange={(e) => setIsChecked(e.target.checked)}
                                            />
                                            <label className="form-check-label text-primary font-weight-semibold" for="termsCheck">
                                            I have accept the <a href="#" className="text-decoration-none text-yellow font-weight-semibold"><u>Terms &amp; conditions</u></a>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-12 d-grid">
                                        <button disabled={!isChecked} className="btn btn-yellow w-100 mb-3 font-weight-bold font-size-18"><span className="d-block py-1">Register</span></button>
                                    </div>
                                </div>
                            </form>

                            <div className="text-center">
                                <p className="mb-3 font-weight-medium font-size-16">Already have an account? <Link to="/signin" className="text-decoration-none text-yellow font-weight-semibold"><u>Login</u></Link></p>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>
                <ClientFooter />
            </main>
        </>
    );
};

export default ClientSignUp;
